
import { PortableText, PortableTextBlock } from 'next-sanity'
import { components } from './rich-text-components'
import { twMerge } from 'tailwind-merge'

export default function RichText({
  text,
  className
}: {
  text?: PortableTextBlock[]
  className?: string
}) {
  if (!text) return null


  return (
    <section className={twMerge('text-lg', className)}>
      <PortableText value={text} components={components} />
    </section>
  )
}
